export const UPDATE = "app/UPDATE";
export const SET_ALERT = "app/SET_ALERT";
export const CLOSE_ALERT = "app/CLOSE_ALERT";
export const SET_SNACK = "app/SET_SNACK";
export const CLOSE_SNACK = "app/CLOSE_SNACK";
